import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseDeleteEstablishmentLeadContractFeeProps {
  establishmentLeadId?: string
  onSuccess?: (response: any) => void
  onError?: () => void
}

export const useDeleteEstablishmentLeadContractFee = ({ establishmentLeadId, onSuccess, onError }: UseDeleteEstablishmentLeadContractFeeProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deleteEstablishmentLeadContractFee'],
    mutationFn: async (id: string) => {
      const lead = {
        contract_attributes: {
          contract_fees_attributes: [
            {
              id,
              _destroy: true
            }
          ]
        }
      }

      await privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
